import { Component, OnInit } from "@angular/core";
import { DataService_MultiStationBlockedVisitors } from "../shared/data.service";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { ConfirmationService } from "primeng/api";
import { VisitorImportRequest } from "../shared/VisitorImportRequest";
import * as moment from "moment";

@Component({
	selector: "app-ms-blocked-visitor-import",
	templateUrl: "./ms-blocked-visitor-import.component.html",
	styleUrls: ["./ms-blocked-visitor-import.component.css"],
})
export class MsBlockedVisitorImportComponent implements OnInit {
	constructor(
		private visitorService: DataService_MultiStationBlockedVisitors,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.loadLists();
	}

	//////////////////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////////////////

	lstVisitorType: any = [];
	lstVisitorStatus: any = [];
	lstRace: any = [];
	lstEthnicity: any = [];

	ImportFileRaw: any;
	lstPreviewImportList: any = [];

	LoadingLists: boolean = true;
	LoadingColumns: boolean = true;
	Processing: boolean = false;

	errorMessage: any = "";

	SkipFirstLine: boolean = false;
	Parsing: boolean = false;
	ImageParsing: boolean = false;
	PhotoCount: number = 0;
	PhotoDisplayCount: number = 0;
	SuccessCount: number = 0;
	ErrorCount: number = 0;
	TotalImagesLoaded: any = [];
	pagerows: number = 5;
	pagefirst: number = 0;
	lstColumnHeaders: any = [];
	lstColumnOptions: any = [];

	PreviewImage: boolean = false;

	//////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////////////////////

	loadLists() {
		this.LoadingLists = true;

		var result = this.visitorService.VisitorModifyListInfoSelect();
		result.subscribe(
			(response: any) => {
				if (response.lstVisitorType != undefined) {
					this.lstVisitorType = response.lstVisitorType;
				}

				if (response.lstVisitorStatus != undefined) {
					this.lstVisitorStatus = response.lstVisitorStatus;
				}

				if (response.lstRace != undefined) {
					this.lstRace = response.lstRace;

					this.lstRace.unshift({
						RaceID: -1,
						RaceDesc: "Not Provided",
					});
				}

				if (response.lstEthnicity != undefined) {
					this.lstEthnicity = response.lstEthnicity;
				}

				this.LoadingLists = false;

				this.loadColumns();
			},
			(error) => {
				this.LoadingLists = false;
			}
		);
	}

	loadColumns() {
		this.LoadingColumns = true;

		var result = this.visitorService.BlockedVisitorImportColumnInfoSelectList();
		result.subscribe(
			(response: any) => {
				this.lstColumnOptions = response;

				this.lstColumnOptions.unshift({
					Description: "Don't Import",
					ColumnValue: "SKIP",
					Required: false,
				});

				this.LoadingColumns = false;
			},
			(error) => {
				this.LoadingColumns = false;
			}
		);
	}
	//////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////////////////

	onSelectImportFile() {
		this.errorMessage = "";

		document.getElementById("SelectedImportFile").click();
	}

	onSelectImportImages() {
		this.errorMessage = "";

		document.getElementById("SelectedImportImages").click();
	}

	onFinish() {
		this.errorMessage = "";

		//
		//#region Error Handling
		//

		// Get list of required columns
		var lstDuplicates: any = [];
		var lstRequired: any = [];
		for (var z = 0; z < this.lstColumnOptions.length; z++) {
			var next = this.lstColumnOptions[z];

			if (next.Required == true) {
				var newItem: any = {
					Description: next.Description,
					ColumnValue: next.ColumnValue,
					ReqMet: false,
				};

				lstRequired = [...lstRequired, newItem];
			}
		}

		// Check that at least one of each exists
		// Check Duplicates
		for (var z = 0; z < this.lstColumnHeaders.length; z++) {
			var next = this.lstColumnHeaders[z];

			for (var i = 0; i < lstRequired.length; i++) {
				var nextRequired = lstRequired[i];

				if (next.ColumnValue == nextRequired.ColumnValue) {
					nextRequired.ReqMet = true;
					break;
				}
			}

			if (next.ColumnValue != "SKIP") {
				var found = false;
				for (var i = 0; i < lstDuplicates.length; i++) {
					var nextDup = lstDuplicates[i];

					if (next.ColumnValue == nextDup.ColumnValue) {
						found = true;
						nextDup.Count++;
						break;
					}
				}
				if (!found) {
					var newDup: any = {
						Description: next.Description,
						ColumnValue: next.ColumnValue,
						Count: 1,
					};

					lstDuplicates = [...lstDuplicates, newDup];
				}
			}
		}

		//
		// Required Columns
		//
		var AnyMissing = false;
		var ReqError = "Missing the required columns: ";
		var lstMissing: any = [];

		for (var z = 0; z < lstRequired.length; z++) {
			var next = lstRequired[z];

			if (next.ReqMet == false) {
				AnyMissing = true;
				lstMissing = [...lstMissing, next.Description];
			}
		}

		if (AnyMissing == true) {
			for (var z = 0; z < lstMissing.length; z++) {
				var next = lstMissing[z];

				ReqError += next;

				if (z < lstMissing.length - 1) {
					ReqError += ", ";
				}
			}

			this.errorMessage = ReqError;
			return;
		}

		var AnyDups = false;
		var DupError = "Duplicate columns: ";
		var lstDupNames: any = [];

		for (var z = 0; z < lstDuplicates.length; z++) {
			var next = lstDuplicates[z];

			if (next.Count > 1) {
				AnyDups = true;
				lstDupNames = [...lstDupNames, next.Description];
			}
		}

		if (AnyDups == true) {
			for (var z = 0; z < lstDupNames.length; z++) {
				var next = lstDupNames[z];

				DupError += next;

				if (z < lstDupNames.length - 1) {
					DupError += ", ";
				}
			}

			this.errorMessage = DupError;
			return;
		}

		//#endregion
		//

		//
		//#region Create Parms
		//
		var DefaultVisitorTypeID: number = 1;
		var DefaultVisitorStatusID: number = 2;
		var lstFirstName: string[] = [];
		var lstMiddleName: string[] = [];
		var lstLastName: string[] = [];
		var lstDOB: string[] = [];
		var lstVisitorTypeID: number[] = [];
		var lstVisitorStatusID: number[] = [];
		var lstGender: string[] = [];
		var lstRaceID: number[] = [];
		var lstEthnicityID: number[] = [];
		var lstAddress: string[] = [];
		var lstCity: string[] = [];
		var lstState: string[] = [];
		var lstZip: string[] = [];
		var lstLicenseNbr: string[] = [];
		var lstPhoneNbr: string[] = [];
		var lstEmail: string[] = [];
		var lstNotes: string[] = [];
		var lstPhotoB64s: string[] = [];

		var lstWatchCols: any = [];
		for (var z = 0; z < this.lstColumnHeaders.length; z++) {
			var next = this.lstColumnHeaders[z];

			if (next.ColumnValue != "SKIP") {
				var nextVal = {
					Index: z,
					ColumnValue: next.ColumnValue,
				};

				lstWatchCols = [...lstWatchCols, nextVal];
			}
		}

		for (var r = 0; r < this.lstPreviewImportList.length; r++) {
			var nextRow = this.lstPreviewImportList[r];

			lstFirstName = [...lstFirstName, ""];
			lstMiddleName = [...lstMiddleName, ""];
			lstLastName = [...lstLastName, ""];
			lstDOB = [...lstDOB, ""];
			lstVisitorTypeID = [...lstVisitorTypeID, -1];
			lstVisitorStatusID = [...lstVisitorStatusID, -1];
			lstGender = [...lstGender, ""];
			lstRaceID = [...lstRaceID, -1];
			lstEthnicityID = [...lstEthnicityID, -1];
			lstAddress = [...lstAddress, ""];
			lstCity = [...lstCity, ""];
			lstState = [...lstState, ""];
			lstZip = [...lstZip, ""];
			lstLicenseNbr = [...lstLicenseNbr, ""];
			lstPhoneNbr = [...lstPhoneNbr, ""];
			lstEmail = [...lstEmail, ""];
			lstNotes = [...lstNotes, ""];
			lstPhotoB64s = [...lstPhotoB64s, ""];

			for (var c = 0; c < nextRow.length; c++) {
				//
				// Skip the column or use the value?
				//
				var WatchCol = false;
				var ColumnValue = "";
				for (var i = 0; i < lstWatchCols.length; i++) {
					var nextWatchCol = lstWatchCols[i];

					if (c == nextWatchCol.Index) {
						WatchCol = true;
						ColumnValue = nextWatchCol.ColumnValue;
						break;
					}
				}

				//
				// Update the list with the column's value
				//
				if (WatchCol == true) {
					var nextCol = nextRow[c];

					if (ColumnValue == "FirstName") {
						lstFirstName[r] = nextCol;
					} else if (ColumnValue == "MiddleName") {
						lstMiddleName[r] = nextCol;
					} else if (ColumnValue == "LastName") {
						lstLastName[r] = nextCol;
					} else if (ColumnValue == "Gender") {
						lstGender[r] = nextCol;
					} else if (ColumnValue == "Address") {
						lstAddress[r] = nextCol;
					} else if (ColumnValue == "City") {
						lstCity[r] = nextCol;
					} else if (ColumnValue == "State") {
						lstState[r] = nextCol;
					} else if (ColumnValue == "Zip") {
						lstZip[r] = nextCol;
					} else if (ColumnValue == "LicenseNbr") {
						lstLicenseNbr[r] = nextCol;
					} else if (ColumnValue == "PhoneNbr") {
						lstPhoneNbr[r] = nextCol;
					} else if (ColumnValue == "Email") {
						lstEmail[r] = nextCol;
					} else if (ColumnValue == "Notes") {
						lstNotes[r] = nextCol;
					} else if (ColumnValue == "DOB") {
						var fDate: string = "";

						try {
							fDate = moment(new Date(nextCol)).format("MM/DD/YYYY");

							if (String(fDate).toLowerCase().indexOf("invalid") != -1) {
								fDate = "";
							}
						} catch (x) {
							x.toString();
						}

						lstDOB[r] = fDate;
					} else if (ColumnValue == "VisitorTypeDesc") {
						var vtID = this.GetVisitorTypeIDByDesc(nextCol);

						lstVisitorTypeID[r] = vtID;
					} else if (ColumnValue == "VisitorStatusDesc") {
						var vsID = this.GetVisitorStatusIDByDesc(nextCol);

						lstVisitorStatusID[r] = vsID;
					} else if (ColumnValue == "RaceDesc") {
						var rID = this.GetRaceIDByDesc(nextCol);

						lstRaceID[r] = rID;
					} else if (ColumnValue == "EthnicityDesc") {
						var eID = this.GetEthnicityIDByDesc(nextCol);

						lstEthnicityID[r] = eID;
					} else if (ColumnValue == "PhotoFileName") {
						lstPhotoB64s[r] = this.GetPhotoByFileName(nextCol);
					}
				}
			}
		}

		var parms: VisitorImportRequest = {
			DefaultVisitorTypeID: DefaultVisitorTypeID,
			DefaultVisitorStatusID: DefaultVisitorStatusID,
			lstFirstName: lstFirstName,
			lstMiddleName: lstMiddleName,
			lstLastName: lstLastName,
			lstDOB: lstDOB,
			lstVisitorTypeID: lstVisitorTypeID,
			lstVisitorStatusID: lstVisitorStatusID,
			lstGender: lstGender,
			lstRaceID: lstRaceID,
			lstEthnicityID: lstEthnicityID,
			lstAddress: lstAddress,
			lstCity: lstCity,
			lstState: lstState,
			lstZip: lstZip,
			lstLicenseNbr: lstLicenseNbr,
			lstPhoneNbr: lstPhoneNbr,
			lstEmail: lstEmail,
			lstNotes: lstNotes,
			lstPhotoB64s: lstPhotoB64s,
		};

		//#endregion
		//

		this.Processing = true;

		var result = this.visitorService.VisitorImport(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "importblocked",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Blocked list imported successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Error Dialog
					this.confirmationService.confirm({
						key: "importblocked",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not import Blocked List.",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	//////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////////////////////////

	onSkipFirstLineChange(val) {
		this.SkipFirstLine = val;

		if (this.ImportFileRaw != undefined) {
			this.ParseBlockList(false);
		}
	}

	onSelectedImportFileChange(val) {
		if (val.target.files != undefined && val.target.files[0] != undefined) {
			var fr = new FileReader();
			fr.onload = (e: any) => {
				this.ImportFileRaw = e.target.result;
				this.ParseBlockList();
			};

			fr.readAsText(val.target.files[0]);
		}
	}

	ParseBlockList(ResetHeaders: boolean = true) {
		this.Parsing = true;

		this.lstPreviewImportList = [];

		//
		// Get Delimiter (Tab or ,)
		//
		var countTAB = 0;
		var countComma = 0;
		var DELIMITER = "\t";

		for (let i = 0; i < this.ImportFileRaw.length; i++) {
			if (this.ImportFileRaw.substr(i, 1) == ",") {
				countComma++;
			}

			if (this.ImportFileRaw.substr(i, 1) == "\t") {
				countTAB++;
			}
		}

		if (countTAB < 2 && countComma < 2) {
			this.errorMessage = "Invalid Block List. delimiter is invalid";
			return;
		} else {
			if (countTAB >= countComma) {
				DELIMITER = "\t";
			} else {
				DELIMITER = ",";
			}
		}

		//
		// Parse List
		//
		this.ImportFileRaw = this.ReplaceAllOccur(this.ImportFileRaw, "\r", "");
		var Lines = this.ImportFileRaw.split("\n");

		var LineToAdd: string[] = [];

		var z = 0;
		if (this.SkipFirstLine == true && Lines.length >= 1) {
			z = 1;
		}

		for (z; z < Lines.length; z++) {
			var next = Lines[z];

			var InQuotes: boolean = false;
			var CurrentStr: string = "";
			LineToAdd = [];

			for (var i = 0; i < Lines[z].length; i++) {
				var nextStr = String(next[i]);

				if (nextStr == '"') {
					InQuotes = !InQuotes;
				} else if (nextStr == DELIMITER) {
					if (InQuotes == false) {
						LineToAdd = [...LineToAdd, CurrentStr];
						CurrentStr = "";
					} else {
						CurrentStr += nextStr;
					}
				} else {
					CurrentStr += nextStr;
				}
			}

			if (CurrentStr != "") {
				LineToAdd = [...LineToAdd, CurrentStr];
			}

			if (LineToAdd.length > 0) {
				this.lstPreviewImportList = [...this.lstPreviewImportList, LineToAdd];
			}
		}

		if (ResetHeaders == true) {
			this.lstColumnHeaders = [];
			for (var z = 0; z < this.lstPreviewImportList[0].length; z++) {
				this.lstColumnHeaders = [...this.lstColumnHeaders, this.lstColumnOptions[0]];
			}
		}

		this.Parsing = false;
	}

	onSelectedImportImagesChange(val) {
		if (val.target.files != undefined) {
			this.ImageParsing = true;
			this.PhotoCount = val.target.files.length;
			this.PhotoDisplayCount = this.TotalImagesLoaded.length + this.PhotoCount;

			if (this.PhotoCount == 0) {
				this.ImageParsing = false;
				return;
			}

			//
			// Start Loading Images
			//
			this.LoadImageAtIndex(val.target.files, 0);
		}
	}

	LoadImageAtIndex(files: any, i: number) {
		var fr = new FileReader();

		fr.onload = (e: any) => {
			this.ImageAtIndexLoaded(e, files, i);
		};

		fr.readAsDataURL(files[i]);
	}

	ImageAtIndexLoaded(e: any, files: any, i: number) {
		this.ResizeImageAndPush(files[i], e.target.result, 640);

		if (i < files.length - 1) {
			this.LoadImageAtIndex(files, i + 1);
		} else {
			this.CheckShowPreview();
			this.ImageParsing = false;
		}
	}

	ResizeImageAndPush(imgfile: any, imgfiledata: any, MAX_SIZE: any) {
		let _this = this;

		// Create work image for resizing
		let img = document.createElement("img");

		img.onerror = function () {
			_this.ErrorCount++;

			//
			// Are We Done Yet?
			//
			if (_this.SuccessCount + _this.ErrorCount[2] == _this.PhotoCount) {
				_this.ImageParsing = false;
			}
		};

		img.onload = function () {
			let width = img.width;
			let height = img.height;

			if (width >= height) {
				// Landscape
				height = Math.round(img.height * (MAX_SIZE / img.width));
				width = MAX_SIZE;
			} else {
				// Portrait
				width = Math.round(img.width * (MAX_SIZE / img.height));
				height = MAX_SIZE;
			}

			let canvas = document.createElement("canvas");

			canvas.width = width;
			canvas.height = height;

			let ctx = canvas.getContext("2d");

			ctx.drawImage(img, 0, 0, width, height);

			let obj = {
				PhotoName: imgfile.name,
				PhotoUrl: canvas.toDataURL("image/jpeg"),
			};

			_this.TotalImagesLoaded.push(obj);
			_this.SuccessCount++;

			if (_this.SuccessCount + _this.ErrorCount == _this.PhotoCount) {
				_this.ImageParsing = false;
			}
		};

		// Load The Image Data
		img.src = imgfiledata;
	}

	onColumnHeaderChange(val, i) {
		this.lstColumnHeaders[i] = val;

		this.CheckShowPreview();
	}

	//////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingLists == true || this.LoadingColumns == true || this.Processing == true || this.Parsing == true || this.ImageParsing == true;
	}

	GetVisitorTypeIDByDesc(desc) {
		var ans = -1;

		for (var z = 0; z < this.lstVisitorType.length; z++) {
			var next = this.lstVisitorType[z];

			if (String(next.VisitorTypeDesc) == String(desc)) {
				ans = next.VisitorTypeID;
				break;
			}
		}

		return ans;
	}

	GetVisitorStatusIDByDesc(desc) {
		var ans = -1;

		for (var z = 0; z < this.lstVisitorStatus.length; z++) {
			var next = this.lstVisitorStatus[z];

			if (String(next.VisitorStatusDesc) == String(desc)) {
				ans = next.VisitorStatusID;
				break;
			}
		}

		return ans;
	}

	GetRaceIDByDesc(desc) {
		var ans = -1;

		for (var z = 0; z < this.lstRace.length; z++) {
			var next = this.lstRace[z];

			if (String(next.RaceDesc) == String(desc)) {
				ans = next.RaceID;
				break;
			}
		}

		return ans;
	}

	GetEthnicityIDByDesc(desc) {
		var ans = -1;

		for (var z = 0; z < this.lstEthnicity.length; z++) {
			var next = this.lstEthnicity[z];

			if (String(next.EthnicityDesc) == String(desc)) {
				ans = next.EthnicityID;
				break;
			}
		}

		return ans;
	}

	ReplaceAllOccur(source: string, searchFor: string, replaceWith: string) {
		let ans: string = source;

		while (ans.indexOf(searchFor) != -1) {
			ans = ans.replace(searchFor, replaceWith);
		}

		return ans;
	}

	GetImportDataImage(row) {
		var Column = 0;
		for (var z = 0; z < this.lstColumnHeaders.length; z++) {
			var nextCol = this.lstColumnHeaders[z];

			if (nextCol.ColumnValue == "PhotoFileName") {
				Column = z;
				break;
			}
		}

		return this.GetPhotoByFileName(row[Column]);
	}

	CheckShowPreview() {
		var AnyPhoto: boolean = false;
		for (var z = 0; z < this.lstColumnHeaders.length; z++) {
			var next = this.lstColumnHeaders[z];

			if (next.ColumnValue == "PhotoFileName") {
				AnyPhoto = true;
				break;
			}
		}

		if (AnyPhoto == true && this.TotalImagesLoaded.length > 0) {
			this.PreviewImage = true;
		} else {
			this.PreviewImage = false;
		}
	}

	GetPhotoByFileName(ToFind: string) {
		for (var z = 0; z < this.TotalImagesLoaded.length; z++) {
			var next = this.TotalImagesLoaded[z];

			if (String(next.PhotoName).toLowerCase() == String(ToFind).toLowerCase()) {
				return next.PhotoUrl;
			}
		}

		return "";
	}

	//////////////////////////////////////////////////////////////////////////////
}
